import React from 'react';

const Svg = (): React.ReactElement => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect opacity="0.6" x="5" y="5" width="22" height="22" rx="11" stroke="#8E8E8E" strokeWidth="2" />
      <rect x="15" y="10" width="2" height="8" rx="1" fill="#8E8E8E" />
      <rect x="15" y="20" width="2" height="2" rx="1" fill="#8E8E8E" />
    </svg>
  );
};

export default Svg;
